import { theme } from "../../../App";

const styles = () => ({
  timeRangeContainer: {
    display: "flex",
    // alignItems: "center",
    [theme.breakpoints.only("xs")]: {
      alignItems: "center",
    },
    [theme.breakpoints.up("sm")]: {
      "& span": {
        marginTop: 12,
      },
    },
  },
  timeInputStyle: {
    padding: "0px",
    [theme.breakpoints.only("xs")]: {
      padding: "12px 0px",
    },
    "& .MuiOutlinedInput-root": {
      padding: 0,
      paddingLeft: 10,
      height: 48,
      width: 178,
      paddingRight: "50px !important",
    },
    "& .MuiAutocomplete-listbox": {
      width: 123,
      height: 48,
      padding: "16px 14px 16px 12px",
      backgroundColor: "#fff",
      fontSize: 14,
    },
  },
});

export default styles;
